/** Contient toutes les chaînes de traduction fr liées au js */
export const fr = {
   // Global
   word: {
      the: "le",
      at: "à",
      error: "Erreur",
      arrival: "Arrivée",
      departure: "Départ",
   },

   // spécifique
   mqtt: {
      event: {
         validation: "vient de valider un titre, nous lui souhaitons bon voyage.",
         order: "vient d'acheter un titre, merci pour sa confiance.",
         registration: "vient de créer son compte MyBus, bienvenue parmi nous.",
         itinerary: "vient de calculer un itinéraire, nous lui souhaitons bon voyage.",
         transfer: "vient de transférer un m-Ticket à un autre utilisateur, voyager avec MyBus n'a jamais été aussi facile.",
         smsticket: "vient d'acheter un ticket SMS, bon voyage.",
         user: "Un utilisateur ",
      },
      noEvent: "MQTT Erreur : Evénement reçu non reconnu",
   },

   geocoder: {
      poi: {
         ACCESS_GATEWAY: "Passerelle d'accès",
         ADMINISTRATIVE_DIVISION: "Division administrative",
         ADVENTURE_SPORTS_VENUE: "Sport d'aventure",
         AGRICULTURE: "Agriculture",
         AIRPORT: "Aéroport",
         AMUSEMENT_PARK: "Parc d'attractions",
         AUTOMOTIVE_DEALER: "Concessionnaire automobile",
         BANK: "Banque",
         BEACH: "Plage",
         BUILDING_POINT: "Bâtiment",
         BUSINESS_PARK: "Parc d'affaires",
         CAFE_PUB: "Pub Café",
         CAMPING_GROUND: "Terrain de camping",
         CAR_WASH: "Lave-Auto",
         CASH_DISPENSER: "Distributeur de billets",
         CASINO: "Casino",
         CINEMA: "Cinéma",
         CITY_CENTER: "Centre-ville",
         CLUB_ASSOCIATION: "Club association",
         COLLEGE_UNIVERSITY: "Université",
         COMMERCIAL_BUILDING: "Bâtiment commercial",
         COMMUNITY_CENTER: "Centre communautaire",
         COMPANY: "Entreprise",
         COURTHOUSE: "Tribunal",
         CULTURAL_CENTER: "Centre culturel",
         DENTIST: "Dentiste",
         DEPARTMENT_STORE: "Grand magasin",
         DOCTOR: "Docteur",
         ELECTRIC_VEHICLE_STATION: "Station VAE",
         EMBASSY: "Ambassade",
         EMERGENCY_MEDICAL_SERVICE: "Urgence",
         ENTERTAINMENT: "Divertissement",
         EXCHANGE: "Échanger",
         EXHIBITION_CONVENTION_CENTER: "Centre expo",
         FERRY_TERMINAL: "Ferry",
         FIRE_STATION_BRIGADE: "Caserne",
         FRONTIER_CROSSING: "Frontière",
         FUEL_FACILITIES: "Station essence",
         GOLF_COURSE: "Terrain de golf",
         GOVERNMENT_OFFICE: "Bureau du gouvernement",
         HEALTH_CARE_SERVICE: "Service de santé",
         HELIPAD_HELICOPTER_LANDING: "Héliport",
         HOLIDAY_RENTAL: "Location de vacances",
         HOSPITAL_POLYCLINIC: "Polyclinique",
         HOTEL_MOTEL: "Hôtel",
         ICE_SKATING_RINK: "Patinoire",
         IMPORTANT_TOURIST_ATTRACTION: "Point d'intérêt",
         INDUSTRIAL_BUILDING: "Bâtiment industriel",
         LEISURE_CENTER: "Centre de loisirs",
         LIBRARY: "Bibliothèque",
         MANUFACTURING_FACILITY: "Usine",
         MARINA: "Marina",
         MARKET: "Marché",
         MEDIA_FACILITY: "Infrastructure médiatique",
         MILITARY_INSTALLATION: "Base militaire",
         MOTORING_ORGANIZATION_OFFICE: "Garage automobile",
         MOUNTAIN_PASS: "Passe montagne",
         MUSEUM: "Musée",
         NATIVE_RESERVATION: "Réservation",
         NIGHTLIFE: "Bar/Discothèque",
         NON_GOVERNMENTAL_ORGANIZATION: "ONG",
         OPEN_PARKING_AREA: "Parking ouverte",
         OTHER: "Autre",
         PARKING_GARAGE: "Parking",
         PARK_RECREATION_AREA: "Aire de loisirs",
         PETROL_STATION: "Station d'essence",
         PHARMACY: "Pharmacie",
         PLACE_OF_WORSHIP: "Lieu de culte",
         POLICE_STATION: "Poste de police",
         PORT_WAREHOUSE_FACILITY: "Port",
         POST_OFFICE: "Bureau de poste",
         PRIMARY_RESOURCE_UTILITY: "Usine",
         PRISON_CORRECTIONAL_FACILITY: "Prison",
         PUBLIC_AMENITY: "Équipement public",
         PUBLIC_TRANSPORT_STOP: "Transports publics",
         RAILWAY_STATION: "Gare",
         RENT_A_CAR_FACILITY: "Location voiture",
         RENT_A_CAR_PARKING: "Location voiture",
         REPAIR_FACILITY: "Réparateur",
         RESEARCH_FACILITY: "Centre de recherche",
         RESIDENTIAL_ACCOMMODATION: "Logement résidentiel",
         RESTAURANT: "Restaurant",
         RESTAURANT_AREA: "Restaurant",
         REST_AREA: "Aire de repos",
         SCENIC_PANORAMIC_VIEW: "Panorama",
         SCHOOL: "Ecole",
         SHOP: "Magasin",
         SHOPPING_CENTER: "Centre commercial",
         SPORTS_CENTER: "Centre sportif",
         STADIUM: "Stade",
         SWIMMING_POOL: "Piscine",
         TENNIS_COURT: "Court de tennis",
         THEATER: "Théâtre",
         TOURIST_INFORMATION_OFFICE: "Office du tourisme",
         TRAFFIC_LIGHT: "Feu de circulation",
         TRAFFIC_SERVICE_CENTER: "Service de circulation",
         TRAFFIC_SIGN: "Signalisation",
         TRAIL_SYSTEM: "Sentier",
         TRANSPORT_AUTHORITY: "Autorité des transports",
         TRUCK_STOP: "Relais routier",
         VETERINARIAN: "Vétérinaire",
         WATER_SPORT: "Sport nautique",
         WEIGH_STATION: "Balance",
         WELFARE_ORGANIZATION: "Organisme d'aide sociale",
         WINERY: "Vignoble",
         ZOOS_ARBORETA_BOTANICAL_GARDEN: "Zoo/Jardin",
      },
   },

   itinerary: {
      mobiscroll: {
         now: "Je pars maintenant",
      },
      tabs: {
         all: "Tous",
         bus: "Bus",
         tram: "Tram",
         metro: "Métro",
         bike: "Vélo",
      },
      filter: {
         DEFAULT: "Le plus rapide",
         MIN_WALKING: "Le moins de marche",
         MIN_TRANSFERS: "Le moins de correspondance"
      },
      position: "Ma position",
      searching: "Nous cherchons l'itinéraire le plus rapide pour vous rendre à destination.",
      noResult: {
         title: "Oups !",
         content: "Aucun résultat trouvé pour cet itinéraire",
      },
      results: {
         single: " itinéraire trouvé",
         plural: " itinéraires trouvés",
         arrivalAt: "Arrivée dans ",
         departureAt: "Départ à ",
         travelTime: "Durée du trajet",
         moreDetails: "Voir le détail",
      },
      searchError: {
         title: "Calcul d'itinéraire - Erreur de saisie",
         sameAddress: "Vous avez renseigné deux fois la même adresse.",
         invalidAddress: "L'adresse renseignée est invalide.",
      }
   },

   geolocalisation: {
      error: {
         title: "Géolocalisation",
         activate: "Vous devez activer la géolocation pour ce site pour accéder à cette fonctionnalité",
      },
   },

   toaster: {
      itinerary: {
         title: "Erreur lors de la recherche d'un itinéraire",
         content: "Aucun trajet trouvé pour votre recherche",
      },
      graphql: {
         title: "Erreur lors de la récupération des données",
      },
      map: {
         content: "Erreur lors de la construction de la map",
      },
   },

   form: {
      newsletter: {
         title: "Lettre d'information",
         valid: "Merci pour votre inscription à notre actualité !",
      },
      contact: {
         title: "Formulaire de contact",
         valid: "Votre demande de contact a bien été envoyée.",
      },
      default: {
         titre: "Formulaire",
         valid: "Votre demande a bien été enregistrée !",
         invalid: "Plusieurs champs présentent des problèmes : <br>",
         reason_politique: "- Vous devez accepter notre politique de confidentialité <br>",
         reason_field: "- Le champ ",
         reason_invalid: " est invalide<br>",
         reason_empty: " est obligatoire<br>",
      }
   },

   map: {
      home: "mapbox://styles/fpacotte/ckc0ns7wz56841io16dkmxcfd",
      itinerary: "mapbox://styles/fpacotte/ck7yrwnbl186e1ilppyyd0nol",
   },
};